import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconResize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconResize"><Path d="M5 19H10V21H3V14H5V19Z" fill="currentColor"/><Path d="M17 17H7V7H17V17Z" fill="currentColor"/><Path d="M21 10H19V5H14V3H21V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconResize;
